module.exports = __webpack_public_path__ + "img/background-system-tile.64b545af.png";